































































































































































































































































































































































































































































import { utils } from "@/util";
import { Vue } from "vue-property-decorator";
import IconePresence from "@/components/icone-presence.vue";
import IconeAbsence from "@/components/icone-absence.vue";
import { PaletteDocument } from "@/models/PaletteDocument";
import { VieQuotidienneDocuments } from "@/models/VieQuotidienneDocument";
export default Vue.extend({
  data() {
    return {
      showMenuMobile: false,
      listPageSize: [50, 100, 250],
      selectPage: 0,
      windowWidth: window.innerWidth,
      selectedRegim: [] as Array<VieQuotidienneDocuments>,
      isPaginationOpen: false,
      selectedPal: {} as PaletteDocument,
    };
  },
  components: {
    IconePresence,
    IconeAbsence,
  },
  props: {
    selectedPageSize: {
      type: Number,
      default: 999,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
    activiteIntitule: {
      type: String,
      default: "Mon activité (titre par défaut)",
    },
    activiteTypeId: {
      type: Number,
      default: -1,
    },
    palettepresence: {
      type: Array,
      default: () => [],
    },
    paletteabsence: {
      type: Array,
      default: () => [],
    },
    vieQuoRegimeAli: {
      type: Array,
      default: () => [],
    },
    countRegim: {
      type: Array,
      default: () => [],
    },
    paletteEnCours: {
      type: PaletteDocument,
    },
  },
  created(){
    this.selectedPal = this.paletteEnCours as PaletteDocument;
  },
  beforeRouteEnter(from, to, next) {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.selectPage = this.selectedPageSize;
    this.$root.$on("bv::dropdown::hide", (bvEvent: any) => {
      if (this.isPaginationOpen && bvEvent.componentId === "dropdownPagination")
        bvEvent.preventDefault();
    });
    next();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    toggleMenu() {
      this.showMenuMobile = !this.showMenuMobile;
    },
    togglePaginationMenu() {
      this.isPaginationOpen = !this.isPaginationOpen;
    },
    selectChange(event: number) {
      this.$emit("change-page-size", event);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth >= 992) this.showMenuMobile = false;
    },
    iconActivite(id: number) {
      return utils.iconActivite(id);
    },
    getImgFromIntitule(regime: string) {
      return utils.getImgFromIntitule(regime);
    },
    totalRegimCount(): number {
      let total: number = this.countRegim.reduce(
        (acc: number, item: any) => acc + item.count,
        0
      );
      return total;
    },
    countRegimAlim(regim: string) {
      let count = 0;
      this.countRegim.forEach((element: any) => {
        if (element["regim_id"] === regim) count += element["count"];
      });
      return count;
    },
    selectRegim(regim: VieQuotidienneDocuments) {
      if (this.selectedRegim.includes(regim)) {
        let index = this.selectedRegim.indexOf(regim);
        this.selectedRegim.splice(index, 1);
      } else {
        this.selectedRegim.push(regim);
      }
    },
    clearRegim() {
      this.selectedRegim = [];
      this.$emit("close-filtre", "regim");
    },
    pushRegim() {
      let params = {
        filtre: "regim",
        value: this.selectedRegim,
      };
      if (this.selectedRegim.length < 1) {
        this.clearRegim();
      } else {
        this.$emit("filtres", params);
      }
      (this.$refs.regimdropdown as Vue & { hide: (b: boolean) => any }).hide(
        true
      );
    },
    selectPalette(palette: PaletteDocument) {
      this.selectedPal = palette;
      this.$emit("selected-palette", palette);
    },
  },
});
